export const extractDateTime = (input: string | undefined | null): string | undefined => {
    if (!input) {
      return undefined;
    }
  
    const match = input.match(/\d{4}-\d{2}-\d{2}/);
    return match ? match[0] : 'Invalid format';
  }